import { Routes, Route, Navigate } from 'react-router-dom';
import React from "react";
import { UserManagementPage } from "../component/admin/UserManagementPage";
import { AdminJobsPage } from "../component/admin/AdminJobsPage";
import { Trading212AdminPage } from "../component/admin/Trading212AdminPage";
import { StockPricesAdminPage } from "../component/admin/StockPricesAdminPage";
import { AlphaSectorOverviewPage } from '../component/alpha/AlphaSectorOverviewPage';
import { AlphaSectorDetailPage } from '../component/alpha/AlphaSectorDetailPage';
import { AlphaStockDetailPage } from '../component/alpha/AlphaStockDetailPage';
import { AlphaAnalystPage } from '../component/alpha/AlphaAnalystPage';
import { SeekingAlphaPage } from "../component/seekingalpha/SeekingAlphaPage";
import { CredentialsManagementPage } from "../component/credentials/CredentialsManagementPage";
import { Trading212Page } from "../component/trading212/Trading212Page";
import { Trading212IsaPage } from "../component/trading212/Trading212IsaPage";
import { Trading212CfdPage } from "../component/trading212/Trading212CfdPage";
import { JobMonitoringPage } from "../component/jobmonitoring/JobMonitoringPage";
import { CallbackUrlManagementPage } from "../component/callback/CallbackUrlManagementPage";
import { MarketCapManagementPage } from "../component/marketcap/MarketCapManagementPage";
import { PortfolioPage } from "../component/portfolio/PortfolioPage";
import { AlphaPicksPage } from "../component/alphapicks/AlphaPicksPage";
import { useUser } from "../context/UserContext";

export function AppRoutes() {
    const user = useUser();

    // Check if the user has access to a specific tool path
    const canAccessRoute = (path: string) => {
        // Admin users can access everything
        if (user.isAdmin) return true;

        // Read-only users can access specific routes
        if (user.isReadOnly) {
            const readOnlyAllowedPaths = [
                '/seeking-alpha',
                '/job-monitoring',
                '/webhooks',
                '/alpha',
                '/alpha-picks',
            ];
            return readOnlyAllowedPaths.includes(path);
        }

        // If user is neither admin nor read-only, they can't access any tool path
        return false;
    };

    const authenticated = user.isAdmin || user.isReadOnly;

    return (
        <Routes>
            <Route path="/" element={authenticated ? <Navigate to="/seeking-alpha" replace /> : null} />
            <Route
                path="/seeking-alpha"
                element={canAccessRoute('/seeking-alpha') ? <SeekingAlphaPage /> : null}
            />
            <Route
                path="/job-monitoring"
                element={canAccessRoute('/job-monitoring') ? <JobMonitoringPage /> : null}
            />
            <Route
                path="/trading212"
                element={user.isAdmin ? <Trading212Page /> : null}
            />
            <Route
                path="/trading212-isa"
                element={user.isAdmin ? <Trading212IsaPage /> : null}
            />
            <Route
                path="/trading212-cfd"
                element={user.isAdmin ? <Trading212CfdPage /> : null}
            />
            <Route
                path="/credentials"
                element={user.isAdmin ? <CredentialsManagementPage /> : null}
            />
            {/* J1: renamed from "Callback URL" to "Webhook notifications". The
                old /callback-url path stays as a redirect for any bookmarked URLs. */}
            <Route
                path="/webhooks"
                element={canAccessRoute('/webhooks') ? <CallbackUrlManagementPage /> : null}
            />
            <Route path="/callback-url" element={<Navigate to="/webhooks" replace />} />
            <Route
                path="/admin/users"
                element={user.isAdmin ? <UserManagementPage /> : null}
            />
            <Route
                path="/admin/jobs"
                element={user.isAdmin ? <AdminJobsPage /> : null}
            />
            <Route
                path="/admin/trading212"
                element={user.isAdmin ? <Trading212AdminPage /> : null}
            />
            <Route
                path="/admin/stock-prices"
                element={user.isAdmin ? <StockPricesAdminPage /> : null}
            />
            <Route
                path="/market-cap"
                element={user.isAdmin ? <MarketCapManagementPage /> : null}
            />
            <Route
                path="/portfolio"
                element={user.isAdmin ? <PortfolioPage /> : null}
            />
            <Route
                path="/alpha-picks"
                element={authenticated ? <AlphaPicksPage /> : null}
            />
            <Route
                path="/alpha"
                element={authenticated ? <AlphaSectorOverviewPage /> : null}
            />
            <Route
                path="/alpha/sectors/:sector"
                element={authenticated ? <AlphaSectorDetailPage /> : null}
            />
            <Route
                path="/alpha/stocks/:ticker"
                element={authenticated ? <AlphaStockDetailPage /> : null}
            />
            <Route
                path="/alpha/analysts/:authorId"
                element={authenticated ? <AlphaAnalystPage /> : null}
            />
        </Routes>
    );
}
